export default "/images/956a9094bb0dc43b1b3c8de5ef813963.avif";